<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Projeto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect  },
  setup() {

  },
  data() {
    return {

      showModalIntera: false,
      projInteraData: {},
      projInterasDada: null,
      submittedProjIntera: false,


      dtListPesqMembro: null,
      projEquipesData: null,
      showModalEquipe: false,
      projEquipeData: {},
      submittedProjEquipe: false,

      projLinksData: null,
      showModalLink: false,
      projLinkData: {},
      submittedProjLink: false,

      updating: true,
      errosValid: null,
      projetoData: {
        id: 0,
        status: 'AB'
      },
      clienteData: { },
      dtListPesqCli: null,
      loadingCliente: false,

      gestorData: { },
      dtListPesqGestor: null,

      idData: 0,
      activeTab: 0,
      submitted: false,

      title: "Editar Projeto",
      items: [
        {
          text: "Projetos",
          href: "/projetos/list",
        },
        {
          text: "Editar Projeto",
          active: true,
        },
      ],

    };
  },

  methods: {

    abrirTarefas(){
      console.log('abrirTarefas')

      console.log('gestaoProjetos')
      this.$router.push('/projeto/tarefas/' + this.idData)

    },

    aprovaProj(){
      console.log('aprovaProj')

      const routeData = this.$router.resolve(`/projeto/aprovar/oo87uuiab65hhas78433klo`)
      window.open(routeData.href, '_blank')



    },


    calculaTotal(){
      let valorBrt = this.projetoData.valorbrt
      let percDesc = this.projetoData.desconto
      if (percDesc > 0) {
        this.projetoData.valorliq = valorBrt - (valorBrt * percDesc / 100)
      }else{
        this.projetoData.valorliq = valorBrt
      }
    },


    novoLink(){
      console.log('novoLink')
      this.projLinkData = {}
      this.submittedProjLink = false
      this.showModalLink = true

    },

    novoMembro(){
      console.log('novoLink')
      this.projEquipeData = {}
      this.submittedProjEquipe = false
      this.showModalEquipe = true

    },

    novaIntera(){
      console.log('novaIntera')
      this.projInteraData = {}
      this.submittedProjIntera = false
      this.showModalIntera = true

    },


    editarUser(idData){
      console.log('editarUser: ' + idData)
      this.$router.push(`/usuario/editar/${idData}`)
    },


    editarLink(dataID){
      console.log('editarLink: ' + dataID)
      this.projLinkData = this.projLinksData.find((reg) => reg.id === dataID);
      this.showModalLink = true
      console.log('regSelecionado: ')
      console.log(this.projLinkData)
    },

    editarEquipe(dataID){
      console.log('editarEquipe: ' + dataID)
      this.projEquipeData = this.projEquipesData.find((reg) => reg.id === dataID);
      this.showModalEquipe = true
      console.log('regSelecionado: ')
      console.log(this.projEquipeData)
    },

    editarInteracao(dataID){
      console.log('editarInteracao: ' + dataID)
      this.projInteraData = this.projInterasDada.find((reg) => reg.id === dataID);
      this.showModalIntera = true
      console.log('regSelecionado: ')
      console.log(this.projInteraData)
    },

    deletarLink(dataID){
      console.log('deletarLink')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projlink`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },

    deletarEquipe(dataID){
      console.log('deletarEquipe')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projequip`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },

    deletarInteracao(dataID){
      console.log('deletarInteracao')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projintera`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },



    abrirUrl(url){
      console.log('abrirUrl')
      window.open(url, '_blank')
    },


    confProjLink(){
      console.log('confProjLink')
      this.submittedProjLink = true

      if (this.projLinkData.url && this.projLinkData.tipo) {

        console.log('formSubmit_validado')
        this.showModalLink = false

        this.projLinkData.projeto_id = this.idData

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/projlink`, {
          projLinkData: this.projLinkData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.clienteData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })
      }
    },

    confProjIntera(){
      console.log('confProjIntera')
      this.submittedProjIntera = true

      if (this.projInteraData.membro && this.projInteraData.tipo) {

        console.log('formSubmit_validado')
        this.showModalIntera = false

        this.projInteraData.projeto_id = this.idData

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/projintera`, {
          projInteraData: this.projInteraData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.clienteData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })
      }
    },


    confProjEquipe(){
      console.log('confProjEquipe')
      this.submittedProjEquipe = true

      // submittedProjEquipe

      if (this.projEquipeData.membro && this.projEquipeData.tipo) {

        console.log('formSubmit_validado')
        this.showModalEquipe = false

        this.projEquipeData.projeto_id = this.idData

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/projequip`, {
          projEquipeData: this.projEquipeData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.clienteData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })
      }
    },

    testarUrl(){
      console.log('testarUrl: ' + this.grampoData.url)
      this.updatingAutomacoes = true

      api.get(`${getBaseUrl()}api/prgrampotst`, {
        params: { url: this.grampoData.url }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.cotacoesData = res.data[0]

        // this.title = `Editar Produto (${this.produtoData.id}) ${this.produtoData.descricao}`

        this.updatingAutomacoes = false
      });
    },


    copiarProjeto(){
      console.log('copiarProjeto')
      this.updating = true
      api.post(`${getBaseUrl()}api/projcopy`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.orctoData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/projeto/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Projeto copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    concluirProj(){
      console.log('concluirProj')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Conclusão de Projeto",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.post(`${getBaseUrl()}api/projconf`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)

            this.projetoData.status = 'CO'

            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Projeto confirmado com sucesso",
              text: "Encaminhar para novo pedido!",
              showConfirmButton: false,
              timer: 1500
            })

          })


        }
      })

    },


    cancelarProj(){
      console.log('cancelarProj')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Projeto",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.post(`${getBaseUrl()}api/projcanc`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)

            this.projetoData.status = 'CA'

            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Projeto cancelado com sucesso",
              showConfirmButton: false,
              timer: 1500
            })

          })


        }
      })

    },



    carregarDados(){

      this.updating = true

      api.get(`${getBaseUrl()}api/projeto`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.projetoData = res.data[0]
        this.idData = this.projetoData.id
        this.title = `Editar Projeto (${this.projetoData.id}) ${this.projetoData.descricao}`

        if (res.data[1]){
          this.clienteData = res.data[1]
          this.dtListPesqCli = [
            {
              'codigo': this.clienteData.codigo,
              'nome': this.clienteData.nome
            },
          ]
        }

        if (res.data[2]){
          this.clienteData = res.data[2]
          this.dtListPesqGestor = [
            {
              'id': this.clienteData.id,
              'name': this.clienteData.name
            },
          ]
        }

        if (res.data[3]){
          this.projLinksData = res.data[3]

        }

        if (res.data[4]){
          this.projEquipesData = res.data[4]

        }

        if (res.data[5]){
          this.projInterasDada = res.data[5]

        }

        console.log('this.dtListPesqCli')
        console.log(this.dtListPesqCli)

        this.updating = false
      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;

      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/projeto`, {
        projetoData: this.projetoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        if (this.idData === 0){
          this.idData = res.data[0].id
          this.projetoData = res.data[0]
          this.$router.replace('/projeto/editar/' + this.idData)
        }

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },

    pesqCliente(evt){
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query, c: 'CL' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },

    escolheuCli(){
      console.log('escolheuCli')
      this.loadingCliente = true
      console.log(this.projetoData.cliente)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.projetoData.cliente }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        // this.ultPedsData = res.data[1]

        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //  totalPed += value.valorliq
        // });

        // this.somaPedidosCli = totalPed
        // this.loadingCliente = false
      })
    },




    pesqGestor(evt){
      console.log('pesqGestor')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqGestor = res.data
        });
      }
    },

    pesqMembro(evt){
      console.log('pesqGestor')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqMembro = res.data
        });
      }
    },

    escolheuGestor(){
      console.log('escolheuGestor')
      console.log(this.projetoData.gestor)
      api.get(`${getBaseUrl()}api/usuario`, {
        params: { iddata: this.projetoData.gestor }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.gestorData = res.data[0]
      })
    },

    escolheuUsuario(){
      console.log('escolheuUsuario')
      console.log(this.projEquipeData.membro)
      api.get(`${getBaseUrl()}api/usuario`, {
        params: { iddata: this.projEquipeData.membro }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        //this.gestorData = res.data[0]
      })
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){

      this.carregarDados()

    }else{

      this.title = `Criando Novo Projeto`
      this.updating = false
    }


  },

  watch: {
    'projetoData.valorbrt': {
      handler() {
        this.calculaTotal()
      }
    },
    'projetoData.desconto': {
      handler() {
        this.calculaTotal()
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="projetoData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit" v-if="projetoData.status === 'AB'" >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>


              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarProjeto">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Copiar
              </b-button>


              <b-button variant="outline-warning" class="mx-2" @click="concluirProj" :disabled="projetoData.status !== 'AB'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Concluir Projeto
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="cancelarProj" :disabled="projetoData.status !== 'AB'">
                <i class="bx bx-purchase-tag-alt font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="aprovaProj">
                <i class="bx bx-check-double font-size-16 align-middle me-2" ></i>
                Aprovação
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" v-if="idData > 0" @click="abrirTarefas">
                <i class="bx bx-calendar font-size-16 align-middle me-2" ></i>
                Tarefas
              </b-button>


            </div>
          </div>
        </div>
      </div>


      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações Principais</h4>
                <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation" @submit.prevent="formSubmit">


                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="descricao">Descrição</label>
                        <input
                            id="descricao"
                            v-model="projetoData.descricao"
                            type="text"
                            class="form-control"
                            placeholder="Descrição"
                            :class="{'is-invalid': submitted && !projetoData.descricao}"/>
                        <div v-if="submitted && !projetoData.descricao"
                             class="invalid-feedback">
                          <span>Campo descrição obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="tipoestab">Tipo</label>
                        <select
                            id="tipoestab"
                            v-model="projetoData.tipo"
                            class="form-control">
                          <option value="UN">Único</option>
                          <option value="PR">Projeto</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="tipoestab">Prioridade</label>
                        <select
                            id="tipoestab"
                            v-model="projetoData.priorid"
                            class="form-control">
                          <option value="1">Prioridade 1</option>
                          <option value="2">Prioridade 2</option>
                          <option value="3">Prioridade 3</option>
                          <option value="4">Prioridade 4</option>
                          <option value="5">Prioridade 5</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="codigo">Código</label>
                      <div class="position-relative">
                        <input
                            id="codigo"
                            type="text"
                            v-model="projetoData.codigo"
                            class="form-control"
                            placeholder="Código"
                            :disabled="true"/>
                      </div>
                    </div>
                  </div>



                  <div class="row mb-3">

                    <div class="col-md-4">
                      <div class="mb-3">
                        <span class="font-size-13">Cliente</span>
                        <multiselect id="inputCliente"
                                     @search-change="pesqCliente"
                                     @select="escolheuCli"
                                     v-model="projetoData.cliente"
                                     placeholder="pesquisar cliente..."
                                     :options="dtListPesqCli"
                                     :searchable="true"
                                     label="nome"
                                     track-by="nome"
                                     value-prop="codigo"
                                     class="mt-2">
                          <template #option="slotProps">
                            <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                            </div>
                            <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.nome }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <span class="font-size-13">Gestor</span>
                        <multiselect id="inputGestor"
                                     @search-change="pesqGestor"
                                     @select="escolheuGestor"
                                     v-model="projetoData.gestor"
                                     placeholder="pesquisar gestor..."
                                     :options="dtListPesqGestor"
                                     :searchable="true"
                                     label="name"
                                     track-by="name"
                                     value-prop="id"
                                     class="mt-2">
                          <template #option="slotProps">
                            <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                            </div>
                            <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.name }}
                              </span>

                              <span class="mx-4" >
                                {{ slotProps.option.tipo }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="pentreg">Previsão de Entrega</label>
                        <input
                            id="pentreg"
                            v-model="projetoData.pentreg"
                            type="date"
                            class="form-control"
                            placeholder="Previsão de Entrega" />
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="pentreg">Conclusão</label>
                        <input
                            id="pentreg"
                            v-model="projetoData.conclusao"
                            type="date"
                            class="form-control"
                            :disabled="true"
                            placeholder="Data de emissão" />
                      </div>
                    </div>




                  </div>

                  <div class=" row mb-3">

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="pentreg">Criado</label>
                        <input
                            id="pentreg"
                            v-model="projetoData.created_at"
                            type="datetime-local"
                            class="form-control"
                            :disabled="true"
                            placeholder="Data de emissão" />
                      </div>
                    </div>

                    <div class="col-md-2">
<!--                      <label for="valorbrt">Valor Bruto</label>-->
<!--                      <input-->
<!--                          id="valorbrt"-->
<!--                          v-model="projetoData.valorbrt"-->
<!--                          type="number"-->
<!--                          class="form-control text-end"-->
<!--                          placeholder="Valor Bruto do Projeto (R$)"/>-->
                    </div>

                    <div class="col-md-2">
<!--                      <label for="desconto">Desconto (%)</label>-->
<!--                      <input-->
<!--                          id="desconto"-->
<!--                          v-model="projetoData.desconto"-->
<!--                          type="number"-->
<!--                          class="form-control text-end"-->
<!--                          placeholder="Desconto (%)"/>-->
                    </div>

                    <div class="col-md-2">
<!--                    <label for="valorbrt">Valor Líquido</label>-->
<!--                      <input-->
<!--                          id="valorbrt"-->
<!--                          v-model="projetoData.valorliq"-->
<!--                          type="number"-->
<!--                          class="form-control text-end"-->
<!--                          :disabled="true"-->
<!--                          placeholder="Valor Líquido do Projeto (R$)"/>-->
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <h5 class="font-size-14">Pesquisar Conteúdo</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            v-model="projetoData.pesqcont">
                          {{ projetoData.pesqcont === 'A' ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <h5 class="font-size-14">Prioridade Dia</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            v-model="projetoData.priodia">
                          {{ projetoData.priodia === 'A' ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                  </div>



                  <div class=" row mb-3">



                  </div>


                  <div class=" row mb-3">



                  </div>

                  <div class=" row mb-3">
                    <div class="mb-12">
                      <label for="obs">Observações</label>
                      <textarea
                          id="obs"
                          v-model="projetoData.obs"
                          type="text"
                          rows="3"
                          class="form-control"
                          placeholder="Observações do Projeto"/>
                    </div>
                  </div>


                </form>




              </div>
            </div>

          </b-card-text>




        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bx-link-external d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Links</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Links (Materiais)</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              @click="novoLink()"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Novo Link
                          </button>
                        </div>
                      </div>
                    </div>

                    <p class="card-title-desc">Entre com a URL de seu conteúdo</p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">URL</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Nível</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="data in projLinksData" :key="data.id">
                          <td> {{ data.id }}</td>

                          <td>
                            <h5 class="font-size-14 text-truncate">

                              <a href="javascript: void(0);" @click="abrirUrl(data.url)">
                                {{ data.url }}
                              </a>

                            </h5>
                            <p class="text-muted mb-0">{{ formatDateTime(data.created_at) }}</p>
                          </td>
                          <td> {{ data.tipo }}</td>
                          <td> {{ data.nivel }}</td>
                          <td> {{ data.status }}</td>
                          <td>
                            <div class="button-items">
                              <b-button variant="outline-success" @click="editarLink(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarLink(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>

                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Fotos
                </button>
              </div>

<!--              <div class="col-sm-6">-->
<!--                <div class="text-end">-->
<!--                  <button-->
<!--                      @click="activeTab = 4"-->
<!--                      class="btn btn-success">-->
<!--                    Avançar para Tabelas de Preços-->
<!--                    <i class="mdi mdi-arrow-right me-1"></i>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </b-card-text>
        </b-tab>



        <b-tab>
          <template v-slot:title>
            <i class="bx bx-sitemap d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Equipe</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Equipe de Composição</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              @click="novoMembro"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Novo Membro
                          </button>
                        </div>
                      </div>
                    </div>

                    <p class="card-title-desc">Entre com a equipe para composição do projeto</p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Telefone</th>
                          <th scope="col">E-mail</th>
                          <th scope="col">Nível</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="data in projEquipesData" :key="data.id">
                          <td> {{ data.id }}</td>

                          <td>
                            <h5 class="font-size-14 text-truncate">

                              <a href="javascript: void(0);" @click="editarUser(data.id)">
                                {{ data.name }}
                              </a>

                            </h5>
                            <p class="text-muted mb-0">{{ formatDateTime(data.created_at) }}</p>
                          </td>
                          <td> {{ data.tel1 }}</td>
                          <td> {{ data.email }}</td>
                          <td> {{ data.nivel }}</td>
                          <td> {{ data.status }}</td>
                          <td>
                            <div class="button-items">
                              <b-button variant="outline-success" @click="editarEquipe(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarEquipe(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>

                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-bot d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Interações</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Interações</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              @click="novaIntera"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Nova Interação
                          </button>
                        </div>
                      </div>
                    </div>

                    <p class="card-title-desc">Entre com a URL de seus fornecedores / concorrentes</p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Membro</th>
                          <th scope="col">Tel1</th>
                          <th scope="col">Email</th>
                          <th scope="col">URL</th>
                          <th scope="col">Nível</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="data in projInterasDada" :key="data.id">
                          <td> {{ data.id }}</td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <a href="javascript: void(0);" @click="editarUser(data.id)">
                                {{ data.name }}
                              </a>
                            </h5>
                            <p class="text-muted mb-0">{{ formatDateTime(data.created_at) }}</p>
                          </td>

                          <td> {{ data.tel1 }}</td>
                          <td> {{ data.email }}</td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <a href="javascript: void(0);" @click="abrirUrl(data.url)">
                                {{ data.url }}
                              </a>
                            </h5>
                          </td>

                          <td> {{ data.nivel }}</td>
                          <td> {{ data.status }}</td>
                          <td>
                            <div class="button-items">
                              <b-button variant="outline-success" @click="editarInteracao(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarInteracao(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>

                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Fotos
                </button>
              </div>

<!--              <div class="col-sm-6">-->
<!--                <div class="text-end">-->
<!--                  <button-->
<!--                      @click="activeTab = 4"-->
<!--                      class="btn btn-success">-->
<!--                    Avançar para Tabelas de Preços-->
<!--                    <i class="mdi mdi-arrow-right me-1"></i>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </b-card-text>
        </b-tab>


      </b-tabs>
    </div>


    <b-modal v-if="projLinkData"
             :title="`${projLinkData.id ? 'Editando Link ' + projLinkData.id : 'Criando Novo Link Para Projeto'}`"
             v-model="showModalLink"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div >


          </div>


          <div class="row">

            <div class="col-md-12">
              <div class="mb-3">
                <label for="url">URL</label>

                <div class="position-relative">
                  <input
                      id="url"
                      v-model="projLinkData.url"
                      type="text"
                      class="form-control"
                      placeholder="URL de acesso"
                      :class="{'is-invalid': submittedProjLink && !projLinkData.url }"/>
                  <div v-if="submittedProjLink && !projLinkData.url" class="invalid-feedback">
                    <span>Campo URL obrigatório, favor preencher.</span>
                  </div>
                  <div class="chat-input-links" v-if="projLinkData.url">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a href="javascript: void(0);"
                           v-b-tooltip.hover
                           placement="top"
                           @click="testarUrl"
                           title="Testar URL">
                          <i class="mdi mdi-text-search"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="tipoprojlink">Tipo</label>
                <select
                    id="tipoprojlink"
                    v-model="projLinkData.tipo"
                    class="form-control"
                    :class="{'is-invalid': submittedProjLink && !projLinkData.tipo}">
                  <option value="DB">DropBox</option>
                  <option value="GD">Google Drive</option>
                  <option value="AM">Amazon</option>
                </select>
                <div v-if="submittedProjLink && !projLinkData.tipo" class="invalid-feedback">
                  <span>Campo tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="nivel">Nível de Acesso</label>
                <select
                    id="nivel"
                    v-model="projLinkData.nivel"
                    class="form-control"
                    :class="{'is-invalid': submittedProjLink && !projLinkData.nivel}">
                  <option value="1">Nível 1</option>
                  <option value="2">Nível 2</option>
                  <option value="3">Nível 3</option>
                </select>
                <div v-if="submittedProjLink && !projLinkData.nivel" class="invalid-feedback">
                  <span>Campo nível obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>


      <div >
        <div class="row mt-3 mb-3">
          <div class="col-md-6">
            <span class="text-primary">Status Automação </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projLinkData.status">
              {{ projLinkData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>

          <div class="col-md-6">
            <span class="text-primary">Alertar Alteração </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projLinkData.alerta">
              {{ projLinkData.alerta === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalLink = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confProjLink">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>




    <b-modal v-if="projEquipeData"
             :title="`${projEquipeData.id ? 'Editando Membro ' + projEquipeData.id : 'Criando Novo Membro Para Projeto'}`"
             v-model="showModalEquipe"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div >

          </div>

          <div class="row mb-3">

            <div class="col-md-12">
              <div class="mb-3">
                <span class="font-size-13">Usuário</span>
                <multiselect id="inputMembro"
                             @search-change="pesqMembro"
                             v-model="projEquipeData.membro"
                             placeholder="pesquisar usuário..."
                             :options="dtListPesqMembro"
                             :searchable="true"
                             label="name"
                             track-by="name"
                             value-prop="id"
                             class="mt-2"
                             :style="submittedProjEquipe && !projEquipeData.membro ? 'border: 1px solid #f86c6b !important;' : ''"

                >
                  <template #option="slotProps">
                    <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                    </div>
                    <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.name }}
                              </span>

                      <span class="mx-4" >
                                {{ slotProps.option.tipo }}
                              </span>
                    </div>
                  </template>
                </multiselect>

                <div v-if="submittedProjEquipe && !projEquipeData.membro">
                  <span class="text-danger font-size-11">Campo usuário obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>


          <div class="row mb-3">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="tipoprojlink">Tipo</label>
                <select
                    id="tipoprojlink"
                    v-model="projEquipeData.tipo"
                    class="form-control"
                    :class="{'is-invalid': submittedProjEquipe && !projEquipeData.tipo}">
                  <option value="CP">Copy</option>
                  <option value="DS">Designer</option>
                  <option value="CO">Corretor Ortográfico</option>
                </select>
                <div v-if="submittedProjEquipe && !projEquipeData.tipo" class="invalid-feedback">
                  <span>Campo tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="nivel">Nível de Acesso</label>
                <select
                    id="nivel"
                    v-model="projEquipeData.nivel"
                    class="form-control"
                    :class="{'is-invalid': submittedProjEquipe && !projEquipeData.nivel}">
                  <option value="1">Nível 1</option>
                  <option value="2">Nível 2</option>
                  <option value="3">Nível 3</option>
                </select>
                <div v-if="submittedProjEquipe && !projEquipeData.nivel" class="invalid-feedback">
                  <span>Campo nível obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>


          <div class="row mb-5">

            <div class="mb-12">
              <label for="obs">Observações</label>
              <textarea
                  id="obs"
                  v-model="projEquipeData.obs"
                  type="text"
                  rows="3"
                  class="form-control"
                  placeholder="Observações"/>
            </div>

          </div>

        </div>
      </div>


      <div >
        <div class="row mt-3 mb-3">
          <div class="col-md-6">
            <span class="text-primary">Status Automação </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projEquipeData.status">
              {{ projEquipeData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>

          <div class="col-md-6">
            <span class="text-primary">Alertar Alteração </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projEquipeData.alerta">
              {{ projEquipeData.alerta === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalEquipe = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confProjEquipe">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>





    <b-modal v-if="projInteraData"
             :title="`${projInteraData.id ? 'Editando Interação ' + projInteraData.id : 'Criando Nova Interação Para Projeto'}`"
             v-model="showModalIntera"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div >


          </div>


          <div class="row">

            <div class="col-md-12">
              <div class="mb-3">
                <span class="font-size-13">Usuário</span>
                <multiselect id="inputMembroIntera"
                             @search-change="pesqMembro"
                             v-model="projInteraData.membro"
                             placeholder="pesquisar usuário..."
                             :options="dtListPesqMembro"
                             :searchable="true"
                             label="name"
                             track-by="name"
                             value-prop="id"
                             class="mt-2"
                             :style="submittedProjIntera && !projInteraData.membro ? 'border: 1px solid #f86c6b !important;' : ''"

                >
                  <template #option="slotProps">
                    <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                    </div>
                    <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.name }}
                              </span>

                      <span class="mx-4" >
                                {{ slotProps.option.tipo }}
                              </span>
                    </div>
                  </template>
                </multiselect>

                <div v-if="submittedProjIntera && !projInteraData.membro">
                  <span class="text-danger font-size-11">Campo usuário obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="tipoprojlink">Tipo</label>
                <select
                    id="tipoprojlink"
                    v-model="projInteraData.tipo"
                    class="form-control"
                    :class="{'is-invalid': submittedProjIntera && !projInteraData.tipo}">
                  <option value="CRC">Criação de Conteúdo</option>
                  <option value="SCO">Solicitar Correção</option>
                  <option value="SAC">Solicitar Aprovação Cliente</option>
                  <option value="AFN">Arquivo Finalizado</option>
                </select>
                <div v-if="submittedProjIntera && !projInteraData.tipo" class="invalid-feedback">
                  <span>Campo tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="nivel">Nível de Acesso</label>
                <select
                    id="nivel"
                    v-model="projInteraData.nivel"
                    class="form-control"
                    :class="{'is-invalid': submittedProjIntera && !projInteraData.nivel}">
                  <option value="1">Nível 1</option>
                  <option value="2">Nível 2</option>
                  <option value="3">Nível 3</option>
                </select>
                <div v-if="submittedProjIntera && !projInteraData.nivel" class="invalid-feedback">
                  <span>Campo nível obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="mb-3">
                <label for="url">URL</label>

                <div class="position-relative">
                  <input
                      id="url"
                      v-model="projInteraData.url"
                      type="text"
                      class="form-control"
                      placeholder="URL de acesso"/>

                  <div class="chat-input-links" v-if="projInteraData.url">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a href="javascript: void(0);"
                           v-b-tooltip.hover
                           placement="top"
                           @click="abrirUrl(projInteraData.url)"
                           title="Abrir URL">
                          <i class="mdi mdi-text-search"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>


              <div class="mb-12">
                <label for="obs">Observações</label>
                <textarea
                    id="obs"
                    v-model="projInteraData.obs"
                    type="text"
                    rows="3"
                    class="form-control"
                    placeholder="Observações"/>
              </div>


          </div>

        </div>
      </div>


      <div >
        <div class="row mt-3 mb-3">
          <div class="col-md-6">
            <span class="text-primary">Status Automação </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projInteraData.status">
              {{ projInteraData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>

          <div class="col-md-6">
            <span class="text-primary">Alertar Alteração </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="projInteraData.alerta">
              {{ projInteraData.alerta === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalIntera = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confProjIntera">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>



    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>




  </Layout>
</template>
